const AiAutoConstant = {
    THREAD_LOG_UPDATE_API: {
        DELETE_LOG: 'DELETE_LOG',
        PAUSE_LOG: 'PAUSE_LOG',
        REPLAY_LOG: 'REPLAY_LOG',
        UPDATE_AUTO_DELETE_LOG_FLAG: 'UPDATE_AUTO_DELETE_LOG_FLAG',
        UPDATE_AUTO_DELETE_OPERATOR_LOG_FLAG: 'UPDATE_AUTO_DELETE_OPERATOR_LOG_FLAG',
        DELETE_OPERATOR_LOG: 'DELETE_OPERATOR_LOG',
        DELETE_TRAINING_LOG: 'DELETE_TRAINING_LOG',
        UPDATE_AUTO_DELETE_TRAINING_LOG_FLAG: 'UPDATE_AUTO_DELETE_TRAINING_LOG_FLAG'
    },

    THREAD_LOG_GET_API: {
        
    },

    THREAD_LOG_PROCESS_STEP: {
        TRIGGER_QUEUE: "TRIGGER_QUEUE", // Thời điểm prompt trong hàng đợi chuẩn bị được gửi cho AI
        REQUEST_API_OPENAI: "REQUEST_API_OPENAI", // Thời điểm gửi nội dung cho AI
        PRE_SIF_FUNCTION: "PRE_SIF_FUNCTION", // Thời điểm trước khi thực hiện sif function từ response AI trả về
    },

    AICHATTHREAD_LOG_STATUS: {
        RUNNING: 'RUNNING',
        PAUSING: 'PAUSING',
        PAUSED: 'PAUSED',
        DONE: 'DONE',
        ERROR: 'ERROR'
    },

    AI_AUTO_LOG_QUERY_LIMIT: 10,

    AI_CHAT_THREAD: {
        DELETE_AI_CHAT_THREAD_BY_ID: 'DELETE_AI_CHAT_THREAD_BY_ID',
        DELETE_AI_CHAT_THREADS: 'DELETE_AI_CHAT_THREADS'
    },

    AICHATTHREAD_TYPE: {
        AI_ASSISTANT: 'AI_ASSISTANT'
    }
}



export default AiAutoConstant;